import { Colors } from "@/enums/Colors";
import { Box, SxProps, styled } from "@mui/material";

const MessageCountContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontSize: "1rem",
  width: "1rem",
  height: "1rem",
  borderRadius: "50%",
  backgroundColor: Colors.DARK_PURPLE_30013F,
  color: Colors.WHITE,
  marginRight: ".4rem",
  justifyContent: "center",
  padding: ".6rem",
}));

interface Props {
  unreadMessagesCount: number;
  sx?: SxProps;
}

export const UnreadMessagesCountComponent = ({ unreadMessagesCount, sx }: Props) => {
  if (unreadMessagesCount == 0) return;

  return <MessageCountContainer sx={sx}>{unreadMessagesCount}</MessageCountContainer>;
};
